<template>
  <div>
    <Drawer v-model="showDrawer" width="80" title="学生转班">
      <Alert>
        <div class="alert-text">
          ①学生转班后，将自动停止在本班级排课及考勤。离班日期后的考勤将会<span
            class="red-text font-bold"
          >自动被删除</span>，可根据实际情况选择离班日期。同时可点击“<span class="normal-text">查看当前班级考勤</span>”进行浏览。
        </div>
        <div class="alert-text">
          ②可查询所要入班的课程（仅支持入班到相同班级），并选择入班时间。入班后新根据入班时间生成对应的考勤日期。
        </div>
      </Alert>
      <div class="content-block">
        <div class="title-line">
          <span class="red-text">*</span>
          <span>离班学生名单</span>
        </div>
        <Table
          ref="leaveTable"
          border
          :columns="leaveStudentsColumn"
          :data="leaveStudents"
          :max-height="450"
        >
          <template slot="sort" slot-scope="{ row, column, index }">
            <span>{{ index + 1 }}</span>
          </template>
          <template slot="historySignNum" slot-scope="{ row, column, index }">
            <span>{{ row.historySignNum }}</span>
            <span
              class="operate-btn-430"
              @click="handleToAttendanceDetail(row)"
            >（查看历史考勤）</span>
          </template>
        </Table>
        <!-- <Page
        :total="leaveStudentPageInfo.total"
        show-total
        :current="leaveStudentPageInfo.pageNum"
        class="page-right"
        @on-change="handleLeaveStudentPage"
      ></Page> -->
      </div>
      <div class="content-big-block">
        <div class="content-block">
          <div class="head-box">
            <div class="title-line">
              <span class="red-text">*</span>
              <span>入班课程班级</span>
            </div>
            <div class="class-tab">
              <div
                v-for="(item, index) in tabList"
                :key="index"
                class="tab-item"
                :class="item.active === tabActive ? 'tab-item-active' : ''"
                @click="handleChangeActive(item.active)"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="search-block">
              <Input
                v-model="classStr"
                style="width: 40%; margin-right: 2%"
                placeholder="请输入入班的课程班级名称"
              ></Input>
              <CascaderYearTerms
                v-if="cacheYearTerms.length === 2"
                class="term-block"
                :cache-year-terms="cacheYearTerms"
                :disabled-year-term="true"
              >
              </CascaderYearTerms>
              <Button type="primary" @click="handleSearchList">搜索</Button>
            </div>
          </div>
          <Table
            ref="enrollClassTable"
            border
            :columns="enrollClassColumn"
            :data="enrollClassData"
            :loading="tableLoading"
            @on-row-click="selectRow"
          >
            <template slot="radio" slot-scope="{ row }">
              <Radio :value="row.classroomId === selectClassId"></Radio>
            </template>
            <template slot="classroomFee" slot-scope="{ row }">
              <span>{{ row.classroomFee / 100 }}</span>
            </template>
          </Table>
          <Page
            :total="pageInfo.total"
            show-total
            :current="pageInfo.pageNum"
            class="page-right"
            @on-change="handlePage"
          ></Page>
        </div>
        <div class="content-right-block">
          <div class="head-box headbox-bottom">
            <div class="title-line">
              <span class="red-text">*</span>
              <span>入班节次</span>
            </div>
          </div>
          <Table
            ref="enrollTimesTable"
            border
            :columns="enrollTimesColumn"
            :data="enrollTimesData"
            :max-height="200"
          >
            <template slot="inClassTime" slot-scope="{ row, column, index }">
              <div class="inclasstime-row">
                <Select
                  v-model="row.timeIndex"
                  style="width: 180px"
                  @on-change="handleChangeClassTime($event, index)"
                >
                  <Option
                    v-for="(x, y) in classTimeList"
                    :key="y"
                    :value="y"
                    :disabled="x.classNo <= row.historySignNum"
                  >第{{ x.classNo }}节（{{ x.classTimeBeginShow }}）</Option>
                </Select>
                <!-- <Icon
                v-if="index === 0"
                class="download-icon"
                type="md-cloud-download"
                size="20"
                @click="batchSetClassEnrollTime"
              ></Icon> -->
              </div>
            </template>
          </Table>
        </div>
      </div>
      <div class="fixed-padding"></div>
      <div class="operation-block operation-430 fixed-bottom">
        <Button class="search-430" @click="handleCancel">取消</Button>
        <Button
          type="primary"
          :loading="submitLoading"
          class="search-430"
          @click="handleSureChange"
        >确定</Button>
      </div>
    </Drawer>
    <OrderAttandanceDrawer
      ref="orderAttandanceDrawer"
      :stu-id="selectStuId"
      :order-id="selectOrderId"
      :classroom-id="selectClassroomId"
      title="查看历史考勤"
    ></OrderAttandanceDrawer>
  </div>
</template>
<script>
import courseSchedulCenter from '@/request/courseSchedulCenter/index.js';
import CascaderYearTerms from '@c/searchBlock/CascaderYearTerms.vue';
import OrderAttandanceDrawer from '@pv/eduCenter/common/assets/components/OrderAttandanceDrawer.vue';
export default {
  name: 'ChangeClassDrawer',
  components: {
    CascaderYearTerms,
    OrderAttandanceDrawer
  },
  props: {
    classroomId: {
      type: String,
      default: ''
    }, // 课班id
    relClassroomId: {
      type: String,
      default: ''
    }, // 商品id
    schoolId: {
      type: String,
      default: ''
    }, // 学校id
    cacheYearTerms: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showDrawer: false, // 是否展示抽屉
      leaveStudentPageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      leaveStudentsColumn: [
        {
          title: '序号',
          slot: 'sort',
          minWidth: 40,
          align: 'center'
        }, {
          title: '学生姓名',
          key: 'studentName',
          minWidth: 120,
          align: 'center'
        }, {
          title: '离班日期',
          key: 'leaveTime',
          minWidth: 290,
          align: 'left'
        }, {
          title: '历史班级考勤节次',
          slot: 'historySignNum',
          minWidth: 290,
          align: 'left'
        }
      ], // 离班设置表头
      leaveStudents: [],
      leaveClassData: [],
      classStr: '', // 搜索的入班课程班级
      enrollClassColumn: [
        {
          title: ' ',
          slot: 'radio',
          minWidth: 40,
          align: 'center'
        }, {
          title: '课程班级名称',
          key: 'classroomName',
          minWidth: 120,
          align: 'center'
        }, {
          title: '学期',
          key: 'termName',
          minWidth: 120,
          align: 'center'
        }, {
          title: '上课时间',
          key: 'timeDesc',
          minWidth: 120,
          align: 'center'
        }, {
          title: '价格（元）',
          slot: 'classroomFee',
          minWidth: 80,
          align: 'center'
        }, {
          title: '累计课时',
          key: 'classroomTotal',
          minWidth: 80,
          align: 'center'
        }
      ], // 入班课程班级的表头
      enrollClassData: [],
      selectClassId: '', // 选择的课程班级id
      pageInfo: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      enrollTimesColumn: [
        {
          title: '学生姓名',
          key: 'studentName',
          minWidth: 120,
          align: 'center'
        }, {
          title: '入班节次',
          slot: 'inClassTime',
          minWidth: 220,
          align: 'center'
        }
      ], // 入班节次的表头
      enrollTimesData: [], //
      classTimeList: [], // 节次列表
      // tabList: [
      //   '其他课程的班级',
      //   '相同课程的班级'
      // ],
      tabList: [
        {
          name: '相同课程的班级',
          active: 1
        },
        {
          name: '其他课程的班级',
          active: 0
        }

      ],
      tabActive: 0, // 哪个tab选中
      submitLoading: false,
      tableLoading: false,
      payOrderIds: [],
      selectStudentData: {},
      selectRowData: {},
      selectStuId: '',
      selectOrderId: '',
      selectClassroomId: ''
    };
  },
  methods: {
    handlePage(page) {
      this.pageInfo.pageNum = page;
      this.getEnrollClassDataTotal();
    },
    // 打开右侧弹窗
    openDrawer(selectStudentData) {
      console.log(selectStudentData, '拿到的已经离班的学生数据------');
      this.getEnrollClassDataTotal();
      this.payOrderIds = [];
      Object.keys(selectStudentData).forEach(item => {
        this.payOrderIds.push(item);
      });
      this.selectStudentData = selectStudentData;
      // this.leaveClassData = selectStudentData.map(item => {
      //   this.payOrderIds.push(item.payOrderId);
      //   return {
      //     ...item
      //   };
      // });
      this.getLeaveStudentData();
      this.showDrawer = true;
    },
    // 获取离班学生数据
    async getLeaveStudentData() {
      const params = {
        payOrderIdList: this.payOrderIds,
        classroomId: this.classroomId,
        pageNum: 1,
        pageSize: this.payOrderIds.length
      };
      const res = await courseSchedulCenter.getStudentHistoryAllSignApi(params);
      if (res.status === 200) {
        this.leaveStudents = res.message.list;
        this.leaveClassData = res.message.list.map(item => {
          return {
            ...item,
            ...this.selectStudentData[item.payOrderId]
          };
        });
        // this.leaveStudentPageInfo.total = +res.message.total;
      }
    },
    handleLeaveStudentPage(pageNum) {
      this.leaveStudentPageInfo.pageNum = pageNum;
      this.getLeaveStudentData();
    },
    // 查看当前班级考勤
    handleToAttendanceDetail(row) {
      const { payOrderId, classroomId, studentId } = row;
      this.selectOrderId = payOrderId;
      this.selectClassroomId = classroomId;
      this.selectStuId = studentId;
      console.log(row, '========');
      this.$nextTick(() => {
        this.$refs.orderAttandanceDrawer.open();
      });
    },
    handleCancel() {
      this.pageInfo = {
        pageNum: 1,
        pageSize: 10,
        total: 0
      };
      this.tabActive = 0;
      this.classStr = '';
      this.selectClassId = '';
      this.enrollClassData = [];
      this.enrollTimesData = [];
      this.showDrawer = false;
    },
    // 获取离班时间
    getLeaveDate(registeredTime, today) {
      const now = new Date(today).valueOf();
      const registerDate = new Date(registeredTime).valueOf();
      if (now < registerDate) {
        return registeredTime;
      } else {
        return today;
      }
    },
    // 批量设置入班节次
    batchSetClassEnrollTime() {
      this.enrollTimesData.forEach((item, index) => {
        if (index !== 0) {
          item.inClassTime = this.classTimeList[this.enrollTimesData[0].timeIndex].classTimeBegin;
          item.timeIndex = this.enrollTimesData[0]['timeIndex'];
        }
      });
    },
    // 选择某一行
    async selectRow(row) {
      this.selectRowData = row;
      this.selectClassId = row.classroomId;
      this.getEnrollClassTime();

      // console.log(this.enrollTimesData, '拿到的入班节次数据------');
    },
    // 获取班级的节次
    async getEnrollClassTime() {
      const params = {
        classroomId: this.selectClassId
      };
      const res = await courseSchedulCenter.getSearchClassroomDetail(params);
      if (res.status === 200) {
        this.classTimeList = res.message.map(item => {
          item.classTimeBeginShow = item.classTimeBegin.split(' ')[0];
          return item;
        });
        this.enrollTimesData = this.leaveClassData.map(item => {
          // console.log(item, '数据----');
          return {
            ...item,
            inClassTime: this.classTimeList[item.historySignNum].classTimeBegin,
            timeIndex: item.historySignNum // 选中第几个节次
          };
        });
      }
    },
    // 选择某个节次
    handleChangeClassTime(value, index) {
      console.log(value, index, '选择节次====');
      if (value === undefined) {
        return;
      }
      const row = this.enrollTimesData[index];
      row.inClassTime = this.classTimeList[value].classTimeBegin;
      row.timeIndex = value;
      this.enrollTimesData.splice(index, 1, row);
    },
    handleChangeActive(index) {
      this.tabActive = index;
      this.pageInfo = {
        pageNum: 1,
        pageSize: 10,
        total: 0
      };
      this.selectClassId = '';
      this.classStr = '';
      this.enrollTimesData = [];
      this.getEnrollClassDataTotal();
    },
    handleSureChange() {
      if (this.enrollTimesData.length === 0) {
        this.$Message.error('没有要转班的学生');
        return;
      }
      if (this.selectClassId === '') {
        this.$Message.error('请先选择要转入的班级');
        return;
      }
      const index = this.enrollTimesData.findIndex(item => {
        return item.inClassTime === '';
      });
      if (index !== -1) {
        this.$Message.error('存在未填的入班节次，请先补充完整！');
        return;
      }
      const leaveClassTimeIndex = this.enrollTimesData.findIndex(item => {
        return item.leaveClassTime === '';
      });
      if (leaveClassTimeIndex !== -1) {
        this.$Message.error('存在未填的离班日期，请先补充完整！');
        return;
      }
      const list = this.enrollTimesData.map(item => {
        return {
          enrollId: item.enrollIdForChange,
          inClassTime: item.inClassTime
          // leaveClassTime: item.leaveClassTime
        };
      });
      // return console.log(list, '====');
      this.submitTrue(list);
    },
    async submitTrue(enrollInfoList) {
      try {
        let res = null;
        this.submitLoading = true;
        this.$Spin.show();
        if (this.tabActive === 1) {
          const params = {
            classroomId: this.selectRowData.classroomId, // 班级id,必填
            productId: this.selectRowData.relClassroomId, // 商品id,必填
            enrollInfoList
          };
          res = await courseSchedulCenter.postStudentBindClass(params);
        } else {
          const params = {
            toClassroomId: this.selectRowData.classroomId, // 班级id,必填
            enrollInfoList
          };
          console.log(params, '拿到的要转班的数据----22222-------');
          res = await courseSchedulCenter.studentBindConvertDiffClass(params);
        }
        this.$Spin.hide();
        if (res.status === 200) {
          this.$Message.success('转班成功');
          this.$emit('refreshData');
          this.handleCancel();
        }
      } finally {
        this.submitLoading = false;
      }
    },
    getEnrollClassDataTotal() {
      if (this.tabActive === 1) {
        this.getEnrollClassData();
      } else {
        this.getEnrollDifferentClassData();
      }
    },
    handleSearchList() {
      this.pageInfo.pageNum = 1;
      this.pageInfo.total = 0;
      this.enrollClassData = [];
      this.getEnrollClassDataTotal();
    },
    // 获取可入班的不同商品课程班级列表
    async getEnrollDifferentClassData() {
      const params = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        relClassroomId: this.relClassroomId,
        termCode: this.cacheYearTerms[1],
        yearCode: this.cacheYearTerms[0]
        // classroomSubStates: '0, 1'
      };
      this.classStr ? params.classroomName = this.classStr : '';
      this.tableLoading = true;
      const res = await courseSchedulCenter.getConvertDiffPageApi(params);
      this.tableLoading = false;
      if (res.status === 200) {
        this.pageInfo.total = Number(res.message.total);
        this.enrollClassData = res.message.list;
      }
    },
    // 获取可入班的班级列表(同商品的)
    async getEnrollClassData() {
      const params = {
        pageNum: this.pageInfo.pageNum,
        pageSize: this.pageInfo.pageSize,
        relClassroomId: this.relClassroomId,
        termCode: this.cacheYearTerms[1],
        yearCode: this.cacheYearTerms[0]
      };
      this.classStr ? params.classroomName = this.classStr : '';
      this.tableLoading = true;
      const res = await courseSchedulCenter.getCourseClassList(params);
      this.tableLoading = false;
      if (res.status === 200) {
        this.pageInfo.total = Number(res.message.total);
        this.enrollClassData = res.message.list;
      }
    }

  }
};
</script>
<style lang="scss" scoped>
.red-text {
  color: #ff3f3f;
}
.normal-text {
  color: #488ffa;
}
.alert-text {
  line-height: 24px;
}
.content-block {
  padding-left: 1%;
  width: 60%;
  box-sizing: border-box;
  /deep/.ivu-table-wrapper {
    overflow: visible;
  }
}
.content-all-block {
  width: 100%;
}
.title-line {
  font-weight: 600;
  margin: 12px 0;
}
.content-big-block {
  display: flex;
  /deep/.ivu-table-wrapper {
    overflow: visible;
  }
  .content-right-block {
    width: 35%;
    margin-left: 2%;
    box-sizing: border-box;
  }
}
.head-box {
  height: 150px;
  display: flex;
  flex-direction: column;
}
.headbox-bottom {
  justify-content: flex-end;
}
.page-right {
  text-align: right;
  margin-top: 16px;
}
.class-tab {
  display: flex;
  margin-bottom: 16px;
  cursor: pointer;
  .tab-item {
    padding: 8px 12px;
    border-bottom: 1px solid transparent;
  }
  .tab-item-active {
    color: #488ffa;
    border-bottom: 1px solid #488ffa;
  }
}
.fixed-padding {
  width: 1px;
  height: 108px;
}
.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  height: 108px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding-right: 24px;
}
.download-icon {
  margin-left: 16px;
  cursor: pointer;
}
.inclasstime-row {
  display: flex;
  align-items: center;
}
.term-block {
  width: 200px;
  margin-right: 16px;
}
.search-block {
  display: flex;
  align-items: center;
}
</style>
